import { ContextStore } from '../../../react-core/Flux/Variables';
import { RoutesHelper } from '../../../react-core/Utils/RoutesHelper';
import { AjaxWrapper } from '../../../react-core/Async/AjaxWrapper';
import { Promise } from '../../../react-core/Async/Promise';
import { NetworkInstructionHistoryPaginatedModel } from '../../Models/Models/Network/NetworkInstructionHistoryPaginatedModel';
import { InstructionStatus } from '../../Constants/Enums/Domain/InstructionStatus';
import { NetworkType } from '../../Constants/Enums/Network/NetworkType';
import { IJsonDate } from '../../System/IJsonDate';
import { NetworkProcessType } from '../../Constants/Enums/Network/NetworkProcessType';

declare var IS_RUNNING_IN_APP_POOL;

export class NetworkInstructionHistoryClient {
  private _culture: string;

  public constructor() {
    var contextStoreState = ContextStore.getContext();
    this._culture = contextStoreState.culture;
  }

  public get(status: Array<InstructionStatus>, networkType: NetworkType, networkName: string, fcaReference: string, createBy: number, dateStartedFrom: IJsonDate, dateStartedTo: IJsonDate, dateUpdatedFrom: IJsonDate, dateUpdatedTo: IJsonDate, networkProcessType: NetworkProcessType, maxRow: number, minRow: number): Promise<NetworkInstructionHistoryPaginatedModel, any> {
    const subResourceUrl = 'robo'
    let actionRoute = '/{culture}/Api/Network/NetworkInstructionHistory/Get';
    if (IS_RUNNING_IN_APP_POOL) actionRoute = '/' + subResourceUrl + actionRoute
    const url = RoutesHelper.replacePlaceholdersInUrl(actionRoute, this._culture).toLowerCase();
    const data = { status: status, networkType: networkType, networkName: networkName, fcaReference: fcaReference, createBy: createBy, dateStartedFrom: dateStartedFrom, dateStartedTo: dateStartedTo, dateUpdatedFrom: dateUpdatedFrom, dateUpdatedTo: dateUpdatedTo, networkProcessType: networkProcessType, maxRow: maxRow, minRow: minRow }

    return AjaxWrapper.get<NetworkInstructionHistoryPaginatedModel, any>(url, data);
  }
}

